interface NodeTextHitPlaneProps {
  width: number;
  height: number;
  x?: number;
  y?: number;
  z: number;
}

const HIT_PLANE_PADDING = 18;

/**
 * 节点网格（椭圆/圆角矩形）无法覆盖文字矩形框的四角，多行文字换行后会超出网格本身的
 * 命中区域，导致鼠标还停留在可见文字上时就先触发了 onPointerOut。这里补一个与文字
 * 矩形同尺寸的不可见命中面，事件冒泡到 group 上已有的 hover/click 处理器，使命中区域
 * 与文字实际可见范围保持一致。
 */
export function NodeTextHitPlane({
  width,
  height,
  x = 0,
  y = 0,
  z,
}: NodeTextHitPlaneProps) {
  return (
    <mesh position={[x, y, z]}>
      <planeGeometry
        args={[width + HIT_PLANE_PADDING, height + HIT_PLANE_PADDING]}
      />
      <meshBasicMaterial transparent opacity={0} depthWrite={false} />
    </mesh>
  );
}
